import React, { PureComponent } from 'react';

import styles from './styles.less';

interface Props {
	children: React.ReactNode;
	styles: {
		panel: string;
	};
}

export default class Panel extends PureComponent<Props> {
	static defaultProps = {
		styles,
	};

	render() {
		const { children, styles } = this.props;

		return <div className={styles.panel}>{children}</div>;
	}
}
